import { defineFormConfig } from "@src/components/business-form";

/** Значения формы поиска СО. */
export interface SearchObjectFormValues {
    /** Номер объекта (СО). */
    objNum: string;
    /**
     * Выбранный вариант навигации (`SearchObjectNavigationVariant.name`). \
     * Пустая строка — вариант ещё не выбран.
     */
    variantName: string;
}

export const searchObjectFormConfig = defineFormConfig<SearchObjectFormValues, SearchObjectFormValues>({
    fields: {
        objNum: {
            type: "string",
            label: "Номер объекта",
            validation: { required: true },
            map: "objNum",
        },
        variantName: {
            type: "string",
            label: "Тип объекта",
            validation: { required: true },
            map: "variantName",
        },
    },
});
